import { TemplateFolder } from './FolderTreeSelector';

/**
 * Recursively finds all descendant folder IDs for a given parent folder
 * @param parentFolderId - The ID of the parent folder
 * @param allFolders - Array of all folders to search through
 * @returns Set of all descendant folder IDs (including the parent folder itself)
 */
export const findDescendantFolderIds = (parentFolderId: string, allFolders: TemplateFolder[]): Set<string> => {
  const descendants = new Set<string>();
  descendants.add(parentFolderId); // Include the parent folder itself

  // Find direct children of the parent folder
  const directChildren = allFolders.filter((folder) => folder.parentFolder?.id === parentFolderId);

  // Recursively find all descendants
  for (const child of directChildren) {
    const childDescendants = findDescendantFolderIds(child.id, allFolders);
    childDescendants.forEach((id) => descendants.add(id));
  }

  return descendants;
};

/**
 * Filters out a folder and all its descendants from a folder list
 * @param folders - Array of folders to filter
 * @param excludeFolderId - ID of the folder to exclude (along with its descendants)
 * @returns Filtered array with excluded folder and its descendants removed
 */
export const filterOutFolderAndDescendants = (folders: TemplateFolder[], excludeFolderId: string): TemplateFolder[] => {
  const descendantIds = findDescendantFolderIds(excludeFolderId, folders);
  return folders.filter((folder) => !descendantIds.has(folder.id));
};
